// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Hjp5M","errorLogs":"styles_errorLogs__1KY_N"};